import type { Logger } from '@core/logging/logger.ts'
import type { SubscriptionToken } from '@core/types/subscription-token.ts'
import type { DomainConfig } from '@core/types/domain-config.ts'

/** @internal */
export type PermissionRequestResponse<TokenType extends SubscriptionToken> = {
    permission: NotificationPermission
    token: TokenType | null
}

/** @internal */
export type PushRegistrationDelegate = {
    _onPushPermissionRequested?(): any
    _onPushPermissionDenied?(): any
    _onPushPermissionDismissed?(): any
    _onPushPermissionGranted?(): any
    _onPushSubscriptionSucceeded?(token: PushSubscriptionJSON): any
    _onPushSubscriptionFailed?(error?: Error): any
}

/** @internal */
export abstract class AbstractPushRegistrationService<TokenType extends SubscriptionToken> {
    public static get _defaultPermissions(): PermissionRequestResponse<any> {
        return {
            permission: 'default',
            token: null,
        }
    }

    protected constructor(
        protected readonly delegate: PushRegistrationDelegate,
        protected readonly domain: DomainConfig,
        protected readonly logger: Logger,
    ) {}

    abstract _getToken(): Promise<TokenType | null>
    abstract _getCurrentPermissions(): Promise<PermissionRequestResponse<TokenType>>
    abstract _requestNotificationPermission(
        currentPermissions?: PermissionRequestResponse<TokenType>,
    ): Promise<PermissionRequestResponse<TokenType> | null>
}
